/* eslint-disable no-underscore-dangle */

declare global {
  interface Window {
    STORIES: unknown;
  }
}

const isStorybookEnv =
  typeof window !== 'undefined' && window.STORIES !== undefined;

export default isStorybookEnv;
